
import {Component, Vue} from "vue-property-decorator";
import api from '@/api'

@Component({name: 'AccountSetting'})
export default class AccountSetting extends Vue {

  mchId: string = ''

  saving = false;
  loading = true;

  created() {
    api.configuration.getSplitOrderPlatformMchId().then(value => {
      this.mchId = value;
      this.loading = false;
    })
  }

  updateValue() {
    this.saving = true
    api.configuration.updateSplitOrderPlatformMchId({mchId: this.mchId}).then(() => {
      this.saving = false
      this.$message.success('童萌的分账收款账号已更新')
    }).catch(()=>{
      this.saving = false;
    })
  }

}
